import type { UploadyContextType } from './types';

const assertContext = (context: UploadyContextType): UploadyContextType => {
  return context;
};

export default assertContext;
